import {
  IAlspSolutionDataFragment,
  IConsultancySolutionDataFragment,
  IEnum_Solution_Producttype,
  IEnum_Solution_Type,
  IProductSolutionDataFragment,
} from 'src/graphql/generated/hooks'

export type SolutionDataFragment =
  | IAlspSolutionDataFragment
  | IConsultancySolutionDataFragment
  | IProductSolutionDataFragment

/** Follow fields from SolutionItem; merged from searchSolutions on compare/detail pages. */
export type SolutionFollowFields = {
  follow?: boolean
  followedSolutionsData?: {
    followingType?: string | null
    followingSolutionNote?: string | null
  } | null
  shared_portfolio_solutions?: Array<{
    category?: string | null
    followingSolutionNote?: string | null
    sharedPortfolio?: string | null
    slug?: string | null
    name?: string | null
    portfolioId?: string | null
    organizationId?: string | null
    members?: string | null
  }> | null
}

export type SolutionDataFragmentWithFollow = SolutionDataFragment & SolutionFollowFields

export const withSolutionFollowFields = (
  solution: SolutionDataFragment,
  followItem?: SolutionFollowFields,
): SolutionDataFragmentWithFollow => ({
  ...solution,
  follow: followItem?.follow ?? false,
  followedSolutionsData: followItem?.followedSolutionsData ?? null,
  shared_portfolio_solutions: followItem?.shared_portfolio_solutions ?? null,
})

export const isProductSolution = (solution: SolutionDataFragment): solution is IProductSolutionDataFragment =>
  solution?.type === IEnum_Solution_Type.Product

export const isAlspSolution = (solution: SolutionDataFragment): solution is IAlspSolutionDataFragment =>
  solution?.type === IEnum_Solution_Type.Alsp

export const isConsultancySolution = (solution: SolutionDataFragment): solution is IConsultancySolutionDataFragment =>
  solution?.type === IEnum_Solution_Type.Consultancy

export const isGraveyardProductSolution = (solution: SolutionDataFragment): solution is IProductSolutionDataFragment =>
  isProductSolution(solution) &&
  solution?.productType === IEnum_Solution_Producttype.Graveyard &&
  !!solution?.graveyardData

export const isConsolidationProductSolution = (
  solution: SolutionDataFragment,
): solution is IProductSolutionDataFragment =>
  isProductSolution(solution) &&
  solution?.productType === IEnum_Solution_Producttype.Consolidation &&
  !!solution?.consolidationData

export const isGraveyardSolution = (solution: SolutionDataFragment): boolean =>
  (solution?.type === IEnum_Solution_Type.Product ||
    solution?.type === IEnum_Solution_Type.Alsp ||
    solution?.type === IEnum_Solution_Type.Consultancy) &&
  solution?.productType === IEnum_Solution_Producttype.Graveyard &&
  !!solution?.graveyardData
